import React from "react";
import "./Input.css";

const Input = props => <div className="input">{props.input}</div>;

export default Input;
